var serverUrl = "";
var serverWebUrl = "";
var serverPrintUrl = "";

function getServerUrl () {
  return serverUrl;
}

function getServerWebUrl () {
  return serverWebUrl;
}

function getServerPrintUrl () {
  return serverPrintUrl;
}

function setServerUrl (url) {
  localStorage.setItem("ystadminurl", url);
  serverUrl = url;
}

function init () {


  //测试版
  //serverUrl = `http://${document.domain}:28001/`
  //后端加代理
  serverUrl = `http://${location.host}/28001/`
  //serverUrl = `https://${location.host}/28001/`
  //serverUrl = `https://${location.host}/smkjyserver/`

  //标准设置
  serverWebUrl = `http://${location.host}/`
  //serverWebUrl = `https://${location.host}/`

  //打印接口
  serverPrintUrl = `http://${document.domain}:28002/`
}

export default {
  getServerUrl, getServerWebUrl, setServerUrl, init, getServerPrintUrl
}



// WEBPACK FOOTER //
// ./src/config/index.js